import type { PersistedTab, SecondaryPostEventPersistedTab } from 'apiConnector/tabs/tabs.model';
import type { AppState } from 'state/state.model';
import { WorkspaceTab } from 'state/workspaces/tabs/tabs.model';

import { combineStatus } from './secondaryMarketPostEvent.utils';

function select(state: AppState, tabId: string) {
  return state.workspaces.secondaryMarketPostEvents[tabId];
}

export function getBcsProductKey(appState: AppState, tabId: string) {
  const secondaryPostEvent = select(appState, tabId);
  return secondaryPostEvent?.bcsProductKey;
}

export function getOrderId(appState: AppState, tabId: string) {
  const secondaryPostEvent = select(appState, tabId);
  return secondaryPostEvent?.orderId;
}

export function getPersistedTabFromSecondaryPostEventsWorkspaceTab(
  appState: AppState,
  tab: WorkspaceTab,
): PersistedTab {
  const secondaryPostEventsTab = select(appState, tab.id);

  return {
    workspace: 'secondaryMarketPostEvents',
    name: tab.name,
    count: tab.count,
    tabContentType: 'secondary-post-event',
    quoteId: secondaryPostEventsTab?.orderId,
    id: tab.id,
    type: secondaryPostEventsTab?.tabType,
  } as SecondaryPostEventPersistedTab;
}

export function getSecondaryMarketPostEventLoadingStatus(state: AppState, tabId: string) {
  const initStatus = select(state, tabId)?.reloadFormStatus ?? 'not_yet';
  const reloadOrderStatus = select(state, tabId)?.reloadOrderStatus ?? 'not_yet';
  return combineStatus(initStatus, reloadOrderStatus);
}

export function findSecondaryPostEventTabByOrderId(state: AppState, orderId: string) {
  const found = Object.entries(state.workspaces.secondaryMarketPostEvents).find(
    ([_tabId, tab]) => tab?.orderId === orderId,
  );
  return found?.[0];
}
